module.exports = __webpack_public_path__ + "static/media/direct.a36991cb.svg";